/* eslint-disable react/display-name */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
import { View, ScrollView, Dimensions } from 'react-native';
import { isNative, isMobileWeb } from '@global/screens';

const { height: windowHeight } = Dimensions.get('window');

const ScrollContainer = forwardRef(
  ({ children, contentContainerStyle = {}, style = {}, ...rest }, ref) => {
    if (!isNative) {
      const styleObj = Array.isArray(style)
        ? Object.assign({}, ...style)
        : style;
      const hasFixedSize =
        styleObj?.height !== undefined || styleObj?.maxHeight !== undefined;
      const shouldScroll = isMobileWeb || hasFixedSize;

      return (
        <View
          ref={ref}
          style={{
            flex: isMobileWeb ? undefined : 1,
            height: isMobileWeb ? windowHeight - 40 : undefined,
            overflow: shouldScroll ? 'auto' : undefined,
            ...styleObj,
          }}
          {...rest}>
          <View
            style={[
              { minHeight: '100%', paddingBottom: isMobileWeb ? 0 : 20 },
              contentContainerStyle,
            ]}>
            {children}
          </View>
        </View>
      );
    }

    return (
      <ScrollView
        ref={ref}
        nestedScrollEnabled={true}
        showsVerticalScrollIndicator={true}
        contentContainerStyle={[{ flexGrow: 1 }, contentContainerStyle]}
        style={style}
        {...rest}>
        {children}
      </ScrollView>
    );
  },
);

export default ScrollContainer;
